<template>
  <v-container class="main-container responsive-height mt5-wrapper">
    <v-row dense>
      <v-col cols="12" class="position-relative">
        <Mt5AllTabs></Mt5AllTabs>
        <div class="mt5-create-account">
          <CreateAccountDropdown></CreateAccountDropdown>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import CreateAccountDropdown from "@/components/GlobalComponents/CreateAccountDropdown";
import Mt5AllTabs from "@/components/PagesComponents/Mt5Page/Mt5AllTabs";
export default {
  components: {
    Mt5AllTabs,
    CreateAccountDropdown,
  },
};
</script>
